<template>
<div>
    <h1 class="mb-4 text-gray-500">Boyfriendtv Downloader</h1>

    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            Demo video
        </h2>
        <div class="mb-4"> Learn how to get started with Boyfriendtv downloader by watching the demo video </div>
        <el-button type="info" size="large" :icon="ElIconVideoPlay" @click="showDemoVideo = true" v-if="!showDemoVideo">Watch video</el-button>

        <video controls autoplay="false" v-show="showDemoVideo">
            <source src="https://anyloader.com/onlyfans_downloader_demo.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </el-card>

    <boyfriendtv-faq></boyfriendtv-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is Boyfriendtv Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Boyfriendtv Downloader is a free Chrome extension that allows you to download videos from Boyfriendtv for offline viewing. Save videos in high quality directly to your device.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does Boyfriendtv Downloader work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Boyfriendtv Downloader uses a Chrome extension to detect and extract video files from Boyfriendtv pages. Simply copy the video URL, paste it into the downloader interface, and the extension will find the downloadable media.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Do I need to create an account?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'No account is required to use Boyfriendtv Downloader. Simply install the Chrome extension and start downloading videos immediately without any registration process.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'What video quality can I download?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'You can download Boyfriendtv videos in their original quality, including HD resolutions. The downloader preserves the video quality as it was uploaded to the site.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free Boyfriendtv Downloader - Download Videos from Boyfriendtv',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos from Boyfriendtv for free using our Chrome extension. Save videos in HD quality for offline viewing. No account required.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'boyfriendtv downloader, download boyfriendtv videos, boyfriendtv video downloader, free boyfriendtv downloader, boyfriendtv chrome extension'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/boyfriendtv-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
            showDemoVideo: false
        }
    }
}
</script>
